export default [
  {
    path: "/extratores",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "extratores_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Extratores", to: "extratores_list" }],
          permission: "extratores:view",
          title: "Extratores",
        },
      },
    ],
  },
];
